import { ApiPath } from "enums";
import { Get } from "utils";

export const getCategoryApi = async (query) => {
  const res = await Get(`${ApiPath.Category}`, query);
  return res.data;
};
